import { toast } from "sonner";
import { api } from "@/lib/api";

// Smart reorder: fetch live stock for each item, add only in-stock ones, skip the rest.
export async function smartReorder(order, cart) {
  const items = order?.items || [];
  if (!items.length) { toast.error("Is order me koi item nahi"); return { added: 0, skipped: [] }; }
  const results = await Promise.all(items.map((it) =>
    api.get(`/products/${it.product_id}`).then((r) => ({ it, p: r.data })).catch(() => ({ it, p: null }))
  ));
  let added = 0;
  const skipped = [];
  for (const { it, p } of results) {
    if (p && p.in_stock) {
      cart.add({ id: it.product_id, name: it.name, price: p.price ?? it.price, image: it.image, unit: it.unit, mrp: it.mrp }, it.quantity, { silent: true });
      added += 1;
    } else {
      skipped.push(it.name);
    }
  }
  if (added > 0) {
    cart.setOpen(true);
    toast.success(skipped.length
      ? `${added} item cart me add hue · ${skipped.length} abhi out of stock (skip kiye)`
      : `${added} item wapas cart me add ho gaye`);
  } else {
    toast.error("Sabhi items abhi out of stock hain");
  }
  return { added, skipped };
}
